import React, { useState, useEffect } from "react";

import './../PopUp.css';
import './GraphData.css';

import { RegisterModalData, RegisterModalObserver, SetModalState } from "../../../interface/PopUp";

import { Svg_Close } from "../../Svg";

interface GraphDataFloorplan {
    floorplan_title     : string;
    floorplan_bathrooms : string;
    floorplan_bedrooms  : string;
    floorplan_size      : string;
    event_count         : number;
}

interface GraphDataProject {
    client  : string;
    project : string;
    list    : GraphDataFloorplan[];
}

interface GraphDataModal {
    data? : {
        city    : string;
        project : GraphDataProject[];
    };
}

function formatValue(value: string | number){
    if (value === "(not set)" || value === "(não definido)") return "---";
    return value;
}

export default function PopUp_GraphData() {

    const [ modalData, setModaldata ] = useState<GraphDataModal>({});
    const [ showPopUp, setShowPopUp ] = useState(false);

    const [ showData, setShowData ] = useState('');
    const [ showProject, setShowProject ] = useState<GraphDataProject[]>([]);

    function ClosePopUp(){
        SetModalState('GraphData', false);
    }

    useEffect(()=>{
        RegisterModalData('GraphData', setModaldata);
        RegisterModalObserver('GraphData', setShowPopUp);
    }, []);

    useEffect(()=>{
        if(showPopUp){
            setShowData(modalData.data?.city ?? '');
            setShowProject(modalData.data?.project ?? []);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showPopUp]);

    return(
        (showPopUp ?
            <div className="PopUp PopUpCenter">
                <div className="all GraphData">
                    <div className="div_title">
                        <div className="">City: { showData }</div>
                        <div className="close" onClick={ ClosePopUp }>
                            <Svg_Close className="icons" color="#B1B2B2" />
                        </div>
                    </div>

                    <div className="div_data">
                        {
                            showProject.map((elem, index)=>{
                                return(
                                    <div className="show_project" key={ "project_" + index }>
                                        <div className="data_project">
                                            <div className="name_client">Client: { elem.client }</div>
                                            <div className="name_project">Project: { elem.project }</div>
                                        </div>
                                        <div className="list_project">
                                            <div className="opt_1">Title</div>
                                            <div className="opt_2">Bathrooms</div>
                                            <div className="opt_2">Bedrooms</div>
                                            <div className="opt_2">Size</div>
                                            <div className="opt_2">Qtd access</div>
                                        </div>
                                        <div className="div_list_loop">
                                            {
                                                elem.list.map((elem_1, index_1)=>{
                                                    return(
                                                        <div className="list_project" key={ "list_" + index_1 }>
                                                            <div className="opt_1">{ formatValue(elem_1.floorplan_title) }</div>
                                                            <div className="opt_2">{ formatValue(elem_1.floorplan_bathrooms) }</div>
                                                            <div className="opt_2">{ formatValue(elem_1.floorplan_bedrooms) }</div>
                                                            <div className="opt_2">{ formatValue(elem_1.floorplan_size) }</div>
                                                            <div className="opt_2">{ formatValue(elem_1.event_count) }</div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="close_all" onClick={ ClosePopUp } />
            </div>
        : <React.Fragment></React.Fragment>)
    )
}
